type IframeProps = {
    src: string;
    height?: string | number;
};

export const Iframe = (props: IframeProps) => {
    const { src, height } = props;

    const url = new URL(src);
    url.searchParams.set("ppup", "Y");

    return <iframe className="w-full" src={url.href} style={{ height }}></iframe>;
};
